<template>
<!-- 主题海报图样式 -->
  <div
    id="zhutiPic"
    class="zhutiPic"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
    v-loading="loading"
  >
  <div class="zhutiContent">
    <div class="recommend" v-if="recommend">
      <span  class="label white">推荐主题:</span>
      <span  class="value white" v-html="recommend"></span>
    </div> 
    <div class="option" v-if="option">
      <span  class="label white">备选主题:</span>
      <span  class="value white" v-html="option"></span>
    </div> 
  </div>
 
  </div>
</template>

<script>
export default {
  name: "zhutiPic",
  data() {
    return {
      loading: false
    };
  },
  props: ["backgroundPic","recommend","option"],
  methods: {
  },

  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
#zhutiPic {
  width: 100%;
  height: 100%;
  /* background: url("../../../static/images/banner02.jpg") no-repeat; */
  background-position: center;
  background-size: cover;
  position: relative;
}

.zhutiContent{
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  top: 440px;
  width: 100%;
}
.zhutiContent > div{
  line-height: 30px;
}
.white{
  color: #fff;
}


</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/zhutiPic.vue